// =======================
// src/estilos/feedbacks.js
// =======================

import { ajustarTamanhoFonteAdmin } from "./global";

export const feedbackInlineBase = {
  width: "100%",
  alignItems: "flex-start",
  borderRadius: 1.5,
  border: "1px solid",
  boxShadow: "none",
  px: 1.75,
  py: 1.25,

  "& .MuiAlert-icon": {
    mt: 0.15,
    mr: 1.25,
    fontSize: 22,
  },

  "& .MuiAlert-message": {
    width: "100%",
    p: 0,
  },
};

export const feedbackInlinePorTipo = {
  error: {
    backgroundColor: "var(--sear-erro-fundo, #fff4f4)",
    borderColor: "var(--sear-erro-borda, #efb8b8)",
    color: "var(--sear-erro-texto, #9f2525)",

    "& .MuiAlert-icon": {
      color: "var(--sear-erro-texto, #d32f2f)",
    },
  },

  warning: {
    backgroundColor: "var(--sear-aviso-fundo, #fff9ed)",
    borderColor: "var(--sear-aviso-borda, #f1d49a)",
    color: "var(--sear-aviso-texto, #865d0d)",

    "& .MuiAlert-icon": {
      color: "var(--sear-aviso-texto, #ed8c00)",
    },
  },

  success: {
    backgroundColor: "var(--sear-sucesso-fundo, #f1faf4)",
    borderColor: "var(--sear-sucesso-borda, #a9d9b7)",
    color: "var(--sear-sucesso-texto, #276738)",

    "& .MuiAlert-icon": {
      color: "var(--sear-sucesso-texto, #2e7d32)",
    },
  },

  info: {
    backgroundColor: "var(--sear-superficie-azul, #eef6ff)",
    borderColor: "var(--sear-borda, #b8d7f5)",
    color: "var(--sear-azul, #235d91)",

    "& .MuiAlert-icon": {
      color: "var(--sear-azul, #087cf0)",
    },
  },
};

export const tituloFeedbackInline = {
  fontSize: ajustarTamanhoFonteAdmin("0.95rem"),
  fontWeight: 700,
  lineHeight: 1.35,
  mb: 0.25,
};

export const mensagemFeedbackInline = {
  fontSize: ajustarTamanhoFonteAdmin("0.875rem"),
  fontWeight: 400,
  lineHeight: 1.45,
};
